<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Time`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1 2.9V5.14505C6.60738 5.59626 3.1001 9.38859 3.1001 14.0001C3.1001 18.9154 7.08476 22.9001 12.0001 22.9001C16.9154 22.9001 20.9001 18.9154 20.9001 14.0001C20.9001 11.7751 20.0836 9.74072 18.7338 8.18037L19.7071 7.20711C20.0976 6.81658 20.0976 6.18342 19.7071 5.79289C19.3166 5.40237 18.6834 5.40237 18.2929 5.79289L17.2633 6.82244C16.0166 5.90669 14.5226 5.30795 12.9 5.14503V2.9H14C14.4971 2.9 14.9 2.49706 14.9 2C14.9 1.50294 14.4971 1.1 14 1.1H12H10C9.50294 1.1 9.1 1.50294 9.1 2C9.1 2.49706 9.50294 2.9 10 2.9H11.1ZM12.0001 6.9001C8.07888 6.9001 4.9001 10.0789 4.9001 14.0001C4.9001 17.9213 8.07888 21.1001 12.0001 21.1001C15.9213 21.1001 19.1001 17.9213 19.1001 14.0001C19.1001 10.0789 15.9213 6.9001 12.0001 6.9001ZM12.9002 11.0002C12.9002 10.5031 12.4973 10.1002 12.0002 10.1002C11.5031 10.1002 11.1002 10.5031 11.1002 11.0002V13.1002H9.0002C8.50314 13.1002 8.1002 13.5031 8.1002 14.0002C8.1002 14.4973 8.50314 14.9002 9.0002 14.9002H12.0002C12.4973 14.9002 12.9002 14.4973 12.9002 14.0002V11.0002Z"/></svg>
</template>
<script>

export default {
  name: 'IconTime',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
